/**
 * EntitiesPage
 *
 * Routed entry for `/entities/:entityId?/records/:recordId?`. Reads the IDs
 * off the URL and, when an entity is named, opens the page scope for the
 * whole subtree via `EntityRecordScope`; with no entity the list renders
 * under the ambient form scope. All record data reaches the content through
 * that scope, never through props.
 */
import { FC } from 'react';

import { EntityRecordScope, useEntityRecordStoreUrlSync } from '@/store';
import EntitiesPageContent from './EntitiesPageContent';

const EntitiesPage: FC = () => {
    const { entityId, recordId } = useEntityRecordStoreUrlSync();

    if (!entityId) return <EntitiesPageContent />;

    return (
        <EntityRecordScope entityId={entityId} recordId={recordId}>
            <EntitiesPageContent />
        </EntityRecordScope>
    );
};

export default EntitiesPage;
